import Vue from 'vue';
import Vuex from 'vuex';
import LocalOfficeInfo from './modules/local-office-info';
import LocationSearch from './modules/location-search';
import OnlineScheduling from './modules/online-scheduling';
import FormContactUs from './modules/form-contact-us';
import NextAvailable from './modules/next-available';
import FormRequestAppointment from './modules/form-request-appointment';
import ClientToken from './modules/client-token';
import GoogleApi from './modules/google-api';
import Globals from './modules/globals';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const cloneState = state => JSON.parse(JSON.stringify(state));

const createModule = module => ({
	...module,
	state: typeof module.state === 'function'
		? module.state
		: () => cloneState(module.state),
});

export default function createStore() {
	return new Vuex.Store({
		modules: {
			LocalOfficeInfo: createModule(LocalOfficeInfo),
			LocationSearch: createModule(LocationSearch),
			OnlineScheduling: createModule(OnlineScheduling),
			FormContactUs: createModule(FormContactUs),
			NextAvailable: createModule(NextAvailable),
			FormRequestAppointment: createModule(FormRequestAppointment),
			ClientToken: createModule(ClientToken),
			GoogleApi: createModule(GoogleApi),
			Globals: createModule(Globals),
		},
		strict: debug,
	});
}
